import type { ToastType } from '../types';

export type PendingCatchFeedback = {
  id: string;
  species?: string;
  location?: string;
  createdAt: number;
  toastType?: ToastType;
  message?: string;
};

const PENDING_CATCH_KEY = 'roddo:fishiq:pending-catch-feedback';
const SIGNAL_SNAPSHOT_PREFIX = 'roddo:fishiq:signal-snapshot:';

function canStore() {
  return typeof window !== 'undefined';
}

export function setPendingCatchFeedback(payload: PendingCatchFeedback) {
  if (!canStore()) return;
  try {
    window.sessionStorage.setItem(PENDING_CATCH_KEY, JSON.stringify(payload));
  } catch {}
}

export function peekPendingCatchFeedback(): PendingCatchFeedback | null {
  if (!canStore()) return null;
  try {
    const raw = window.sessionStorage.getItem(PENDING_CATCH_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PendingCatchFeedback;
  } catch {
    return null;
  }
}

export function consumePendingCatchFeedback(): PendingCatchFeedback | null {
  if (!canStore()) return null;
  try {
    const raw = window.sessionStorage.getItem(PENDING_CATCH_KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(PENDING_CATCH_KEY);
    return JSON.parse(raw) as PendingCatchFeedback;
  } catch {
    return null;
  }
}

export function getSignalSnapshot(geo5: string): number | null {
  if (!canStore() || !geo5) return null;
  try {
    const raw = window.localStorage.getItem(`${SIGNAL_SNAPSHOT_PREFIX}${geo5}`);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function setSignalSnapshot(geo5: string, total: number) {
  if (!canStore() || !geo5) return;
  try {
    window.localStorage.setItem(`${SIGNAL_SNAPSHOT_PREFIX}${geo5}`, String(Number(total) || 0));
  } catch {}
}

export function getSignalDelta(geo5: string, nextTotal: number) {
  const previous = getSignalSnapshot(geo5);
  const safeNext = Number.isFinite(Number(nextTotal)) ? Number(nextTotal) : 0;
  const delta = previous == null ? null : safeNext - previous;
  return { previous, next: safeNext, delta };
}